// src/components/network/ForfeoAppCTA.tsx
import { ArrowRight, Smartphone, WalletCards } from 'lucide-react';
import { buildForfeoMobileDeepLink } from '../../lib/forfeoNetwork';

type ForfeoAppCTAProps = {
  target?: 'experience' | 'reservation' | 'wallet' | 'last_call';
  id?: string | number | null;
  label?: string;
  className?: string;
};

export function ForfeoAppCTA({ target = 'experience', id, label = 'Réserver dans l’app', className = '' }: ForfeoAppCTAProps) {
  const href = buildForfeoMobileDeepLink({
    target,
    id: id ? String(id) : undefined,
    source: 'forfeo_explore',
    fallbackUrl: target === 'last_call' ? 'https://forfeoexplore.com/last-call' : 'https://forfeoexplore.com/boutique',
  });

  return (
    <a
      href={href}
      className={`inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-purple-600 to-blue-600 px-5 py-3 text-xs font-black uppercase tracking-[0.16em] text-white shadow-lg shadow-purple-600/20 transition hover:-translate-y-0.5 hover:shadow-purple-600/30 ${className}`.trim()}
    >
      <Smartphone size={16} />
      {label}
      <WalletCards size={16} />
      <ArrowRight size={15} />
    </a>
  );
}

export default ForfeoAppCTA;
